export const LOAD_LOCATIONS = "LOCATIONS/LOAD_LOCATIONS";
export const RESET_FILTERED_LIST = "LOCATIONS/RESET_FILTERED_LIST";
export const SET_FILTERED_LIST = "LOCATIONS/SET_FILTERED_LIST";
export const SET_LOADING = "LOCATIONS/SET_LOADING";
export const SET_SKELETON = "LOCATIONS/SET_SKELETON";
